import DateTime from 'common/components/DateTime/DateTime';
import styles from './DescriptorValue.scss';
import { verifyInputFormat } from 'common/util/dateTime';

const DateOnlyAttribute = (value) => {
    return <DateTime value={value} inputFormat={verifyInputFormat(value)} className={styles.attributeValue} />;
};

const DateTimeAttribute = (value) => {
    return <DateTime className={styles.attributeValue} inputFormat={verifyInputFormat(value)} value={value} time={true} />;
};

const Attribute = (value) => {
    return <span className={styles.attributeValue}><p>{value}</p></span>;
};

const attributeTypes = {
    SMALL_TEXT: Attribute,
    LARGE_TEXT: Attribute,
    BOOLEAN: Attribute,
    INTEGER: Attribute,
    REAL: Attribute,
    DATASET: Attribute,
    DATETIME: DateTimeAttribute,
    DATEONLY: DateOnlyAttribute
};

const DescriptorValue = ({ value, dataType }) => {
    const attribute = attributeTypes[dataType.toUpperCase()];

    if (!attribute) {
        throw new Error(`DescriptorValue: Must provide one of the folliwng as dataType, ${Object.keys(attributeTypes)}`);
    }

    return attribute(value);
};

export default DescriptorValue;
